import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_merchant_rate_card_RowClass,
  bl_pgw_merchant_rate_card_RowInterface,
} from '../../dbschema';
import {
  bl_pgw_merchant_rate_card_line_RowInterface,
  bl_pgw_merchant_rate_card_line_RowClass,
} from '../../dbschema';

export class RateCardContainerModel extends BaseContainerModel {
  bl_pgw_merchant_rate_card: bl_pgw_merchant_rate_card_RowInterface = new bl_pgw_merchant_rate_card_RowClass();
  bl_pgw_merchant_rate_card_line: bl_pgw_merchant_rate_card_line_RowInterface[] = [];

}
